import { Stack, Typography } from '@mui/material'
import ModalDialog from '../modal-dialog/ModalDialog'

const FIRST_PUBLISH_LINES = [
    'פרסום המודעה יקפיא את תוכנה לצמיתות, ולא ניתן יהיה לערוך אותו שוב.',
    'ביטול הפרסום לא ישחרר את התוכן לעריכה.',
    'כדי לשנות את התוכן אפשר לשכפל את המודעה ולערוך את השכפול.',
]

const REPUBLISH_LINES = [
    'המודעה תוצג שוב לכל המשתמשים.',
]

export default function PublishConfirmation({
    open = false,
    isContentLocked = false,
    onConfirm,
    onCancel,
}) {
    const lines = isContentLocked ? REPUBLISH_LINES : FIRST_PUBLISH_LINES

    const commands = [
        {
            label: 'אישור',
            onClick: () => onConfirm?.(),
        },
        {
            label: 'ביטול',
            color: 'secondary',
            onClick: () => onCancel?.(),
        },
    ]

    return (
        <ModalDialog
            open={open}
            title="פרסום מודעה"
            commands={commands}
            onClose={() => onCancel?.()}
        >
            <Stack spacing={1}>
                {lines.map((line) => (
                    <Typography key={line} variant="body2">{line}</Typography>
                ))}
            </Stack>
        </ModalDialog>
    )
}
